/**
 * Convert YouTube URL to embed format
 * Supports various YouTube URL formats:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 * - https://youtube.com/watch?v=VIDEO_ID
 * @param {string} url - YouTube URL
 * @returns {string|null} Embed URL or null if invalid
 */
export const convertYouTubeUrlToEmbed = (url) => {
  if (!url || typeof url !== 'string') return null;

  // If already in embed format, return as is
  if (url.includes('youtube.com/embed/')) {
    return url;
  }

  // Extract video ID from various YouTube URL formats
  let videoId = null;

  // Pattern 1: https://www.youtube.com/watch?v=VIDEO_ID
  const watchMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s?#]+)/);
  if (watchMatch) {
    videoId = watchMatch[1];
  }

  // Pattern 2: https://youtu.be/VIDEO_ID
  if (!videoId) {
    const shortMatch = url.match(/youtu\.be\/([^&\s?#]+)/);
    if (shortMatch) {
      videoId = shortMatch[1];
    }
  }

  // Pattern 3: Already has video ID in embed format
  if (!videoId) {
    const embedMatch = url.match(/embed\/([^&\s?#]+)/);
    if (embedMatch) {
      videoId = embedMatch[1];
    }
  }

  // If we found a video ID, return embed URL
  if (videoId) {
    return `https://www.youtube.com/embed/${videoId}`;
  }

  // If no valid pattern found, return null
  return null;
};

/**
 * Check if URL is a valid YouTube URL
 * @param {string} url - URL to check
 * @returns {boolean} True if valid YouTube URL
 */
export const isValidYouTubeUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return /(?:youtube\.com|youtu\.be)/.test(url);
};




